import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/dataManagement';
const gap: Array<RouteConfig> = [
    {
        path: 'data-manage/gap',
        name: 'gap',
        redirect: { name: 'gapSettings' },
        meta: {
            menuMatch: 'gapSettings',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'settings',
                name: 'gapSettings',
                component: () => import(`@/${BASE_PATH}/standard/Standard.vue`),
                meta: {
                    index: '5',
                    type:'GAP',
                    subPage:'gapSettingsDetail'
                },
            },
            {
                path: 'detail',
                name: 'gapSettingsDetail',
                component: () => import(`@/${BASE_PATH}/standard/StandardDetail.vue`),
                meta: {
                    index: '5',
                    type:'GAP',
                    supPage:'gapSettings',
                    noBottom:true
                },
            },
        ],
    },
];
export default gap;